<template>
  <!-- เมนูกระบวนงาน — แก้รายการเมนูที่ adminProcessMenus.js (teacherTransfer) -->
  <AdminProcessNav v-bind="menu" />
</template>

<script>
import AdminProcessNav from "./AdminProcessNav.vue";
import { ADMIN_MENUS } from "./adminProcessMenus";

export default {
  name: "HRvecMovementMenu",
  components: { AdminProcessNav },
  data() {
    return { menu: ADMIN_MENUS.teacherTransfer };
  }
};
</script>
